import { TableColumnGroup } from "../../../shared/scripts/table-column-visibility";


export class UserRequest {
    Id: number;
    Email: string;
    FirstName: string;
    LastName: string;
    Organization: string;
    TLCRole: string;
    AffiliationId: number;
    SiteInfo: string;
    Roles: string[]
    StatusId: number;
    UserId?: number; 
    SiteId: number;
}

export class NewUser {
    Id: number;
    Email: string;
    FirstName: string;
    LastName: string;
    Organization: string;
    TLCRole: string;
    AffiliationId: number;
    SiteInfo: string;
    RTINIHAccess: number;
    ProtocolDevelopmentAccess: number;
    LDNAccess: number;
    GLP1Access: number;
    BariAccess: number;
    SGBAccess: number;
    LDNFinAccess: number;
    GLP1FinAccess: number;
    BariFinAccess: number;
    SGBFinAccess: number;
    CABAccess: number;
    SCCAccess: number;
    SiteInterestAccess: number;
    PublicCommentAccess: number;
    RVLCSafetyAccess: number;
    LdnBioAccess: number;
    VendorAlcami: number;
    StatusId: number;
    UserId?: number;
}

export class CurrentUserWithRequest {
    UserId: number;
    Email: string;
    FirstName: string;
    LastName: string;
    Organization: string;
    ProjectRole: string;

    RequestId: number;
    StatusId: number;

    LDNAccess: number;
    GLP1Access: number;
    BariAccess: number;
    SGBAccess: number;
    CABAccess: number;
    SCCAccess: number;
    SiteInterestAccess: number;
    PublicCommentAccess: number;
    RVLCSafetyAccess: number;
    LdnBioAccess: number;
    VendorAlcami: number;
    ProtocolDevelopmentAccess: number;
    RTINIHAccess: number;

    RequestedData: UserRequest;
}

export class UpdateRequest {
    Id: number;
    Email: string;
    FirstName: string;
    LastName: string;
    Organization: string;
    TLCRole: string;
    StatusId: number;
    TypeId: number;
    UserId?: number;
    RequestJson: string;
}

export class portalRoles {
    // roles used to access parts of the portal
    id: number;
    Name: string;
    DisplayName?: string;
}

export class CurrentUser {
    Id: number;
    Email: string;
    FirstName: string;
    LastName: string;
    IsActive: boolean;
    Organization: string;
    ProjectRole: string;
    SentWelcomeEmail: number;
    AffiliationId: number;
    Roles: string[]
}
